export default __webpack_public_path__ + "static/ue-logo-1-0052b4503703621520ffe54b9b5a812f.svg";